export interface WorkspaceOperationNotice {
  operationType: string;
  idempotencyKey: string;
  status: "pending" | "unknown" | "resolved";
  resultState?: string;
}

export type WorkspaceOperationAction =
  | { type: "start"; notice: WorkspaceOperationNotice }
  | { type: "restore-sourcing"; notices: WorkspaceOperationNotice[] }
  | { type: "reset" }
  | { type: "unknown"; idempotencyKey: string }
  | { type: "resolved"; idempotencyKey: string; resultState: string }
  | { type: "clear"; idempotencyKey: string };

export function hasUnresolvedOperation(
  operations: WorkspaceOperationNotice[],
  operationType: string,
) {
  return operations.some(
    (item) =>
      item.operationType === operationType && item.status !== "resolved",
  );
}

export function workspaceOperationsReducer(
  state: WorkspaceOperationNotice[],
  action: WorkspaceOperationAction,
): WorkspaceOperationNotice[] {
  if (action.type === "reset") return [];
  if (action.type === "restore-sourcing") {
    return [
      ...state.filter((item) => !item.operationType.startsWith("sourcing.")),
      ...action.notices,
    ];
  }
  if (action.type === "start") {
    if (
      state.some((item) => item.idempotencyKey === action.notice.idempotencyKey)
    )
      return state;
    return [...state, action.notice];
  }
  if (action.type === "clear")
    return state.filter(
      (item) => item.idempotencyKey !== action.idempotencyKey,
    );
  const terminal =
    action.type === "resolved" &&
    ["completed", "failed"].includes(action.resultState.toLowerCase());
  const status: WorkspaceOperationNotice["status"] =
    action.type === "resolved"
      ? terminal
        ? "resolved"
        : "unknown"
      : action.type;
  return state.map((item) =>
    item.idempotencyKey === action.idempotencyKey
      ? {
          ...item,
          status,
          resultState:
            action.type === "resolved" ? action.resultState : undefined,
        }
      : item,
  );
}
